import { render, staticRenderFns } from "./VariantSifterAnnotationsWorkspaceTrack.vue?vue&type=template&id=f4bf4bdc&scoped=true&"
import script from "./VariantSifterAnnotationsWorkspaceTrack.vue?vue&type=script&lang=js&"
export * from "./VariantSifterAnnotationsWorkspaceTrack.vue?vue&type=script&lang=js&"
import style0 from "./VariantSifterAnnotationsWorkspaceTrack.vue?vue&type=style&index=0&id=f4bf4bdc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4bf4bdc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f4bf4bdc')) {
      api.createRecord('f4bf4bdc', component.options)
    } else {
      api.reload('f4bf4bdc', component.options)
    }
    module.hot.accept("./VariantSifterAnnotationsWorkspaceTrack.vue?vue&type=template&id=f4bf4bdc&scoped=true&", function () {
      api.rerender('f4bf4bdc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/kpVariantSifter/VariantSifterAnnotationsWorkspaceTrack.vue"
export default component.exports